module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "inkooporder aanmaken"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("\n        Inkooporder\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content p-0 row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderListName),
      expression: "orderListName"
    }],
    ref: "searchInput",
    staticClass: "form-control",
    attrs: {
      "placeholder": "Geef een naam aan de bestelling"
    },
    domProps: {
      "value": (_vm.orderListName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orderListName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "options": _vm.brands,
      "placeholder": "Selecteer een leverancier",
      "selected-label": "✔",
      "select-label": "",
      "deselect-label": "✔"
    },
    model: {
      value: (_vm.supplier),
      callback: function($$v) {
        _vm.supplier = $$v
      },
      expression: "supplier"
    }
  })], 1)])]), _vm._v(" "), (_vm.fromScratch) ? _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("\n        Producten toevoegen\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-noborder",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.openUnknownProductModal
    }
  }, [_vm._v("\n          Nieuw product toevoegen aan inkooporder\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content p-0 row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productName),
      expression: "productName"
    }],
    ref: "searchInput",
    staticClass: "form-control",
    attrs: {
      "list": "products",
      "placeholder": "Vul een product naam in"
    },
    domProps: {
      "value": (_vm.productName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.productName = $event.target.value
      }, _vm.getProducts]
    }
  }), _vm._v(" "), _c('datalist', {
    attrs: {
      "id": "products"
    }
  }, _vm._l((_vm.products), function(item) {
    return _c('option', {
      key: item.id
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-noborder",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.addProductToOrderList
    }
  }, [_vm._v("\n          Toevoegen aan inkooporder\n        ")])])]) : _vm._e(), _vm._v(" "), (_vm.fromScratch) ? _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("\n        Producten in inkooporder\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    staticClass: "table table-borderless table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "150px"
    }
  }, [_vm._v("EAN")]), _vm._v(" "), _c('th', [_vm._v("Product")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.orderListProducts), function(product) {
    return _c('tr', {
      key: product.id
    }, [_c('td', [_c('a', {
      staticClass: "font-w600",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(product.gtin))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(product.name))])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-noborder",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.createOrderList
    }
  }, [_vm._v("\n    Maak een nieuwe inkooporder aan\n  ")]), _vm._v(" "), (_vm.showUnknownProductModal) ? _c('unkown-product-modal', {
    attrs: {
      "barcode": _vm.unknownProductBarcode
    },
    on: {
      "close": function($event) {
        _vm.showUnknownProductModal = null, _vm.unknownProductBarcode = null
      },
      "unkownProductCreated": _vm.handleUnkownProductCreated
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67c31000","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/order-lists/CreateOrderListModal.vue
// module id = 727
// module chunks = 1